export default __webpack_public_path__ + "static/media/Slide51.5ca17558.PNG";